// extracted by mini-css-extract-plugin
export default {"title":"page_title__lWb3N","article":"page_article__gXhrH","titleElement":"page_titleElement__FIJus","sortOptions":"page_sortOptions__9eHvl","preTitle":"page_preTitle__W1yWG"};